import React, { useState } from 'react';
import { IDomainResult } from '@app/models';
import { useTypedTranslation } from '@app/hooks';
import { Collapse, Link } from '@material-ui/core';
import { createTranslation } from '@app/helpers';
import { VerifiedUser, Error, Warning, Assignment } from '@material-ui/icons';
import { orange, green } from '@material-ui/core/colors';

interface IProps {
    result: IDomainResult;
    index: number;
}

export const DomainResults = ({ result, index }: IProps) => {

    const { translation } = useTypedTranslation();

    const [expanded, setExpanded] = useState<boolean>(false);

    const getIcon = (state: string) => {
        if (state === 'valid') {
            return <VerifiedUser className='msol-icon' htmlColor={green[700]} />
        }
        else if (state === 'warning') {
            return <Warning className='msol-icon' htmlColor={orange[500]} />
        }
        else {
            return <Error className='msol-icon' color='error' />
        }
    }

    return (
        <li key={index} style={{ marginBottom: '5px' }}>
            {getIcon(result.state)}
            <span className='domainresults-span'>{result.message}&nbsp;</span>
                {result.moreInfo && (
                    <Link onClick={(e: any) => {
                        e.preventDefault();
                        setExpanded(!expanded)
                    }}>{translation('MSOL_MORE_INFO')}</Link>
                )}
            <Collapse in={expanded} timeout='auto'>
                <ul className='more-info'>
                    {result.moreInfo?.messages.map((message, index: number) => (
                        <li key={index}>
                            <span>{result.moreInfo?.icon && <Assignment />}</span>
                            <span className='domainresults-span'>{translation(createTranslation(message)) === '' ? message : translation(createTranslation(message))}</span>
                        </li>
                    ))}
                </ul>
            </Collapse>
        </li>
    );
};
